import React from 'react';
import { Link } from "react-router-dom";
import "./bird.css";
import { FaBinoculars, FaFeather, FaMapMarkedAlt } from "react-icons/fa";

function BirdWatching() {

  const wildlifeAreas = [
      { 
    name: "Kumana National Park", 
    highlight: "Famous for seasonal waterbird gatherings", 
    image: "/kumana.jpeg" 
  },
    { 
    name: "Sinharaja Forest Reserve", 
    highlight: "UNESCO rainforest with rare endemic birds", 
    
    image: "/sinharaja.jpg" 
  },
    { 
    name: "Bundala National Park", 
    highlight: "Coastal sanctuary for migratory birds", 
    image: "/bundala b.jpg" 
  },

  { 
    name: "Yala National Park", 
    highlight: "Best for leopard sightings and diverse bird species", 
    image: "/yala b.jpg" 
  },


];






  return (
    <div className="bird-page">

   {/* Main Banner - Same as before */}
      <div className="banner-section">
        <div className="banner-overlay"></div>
        <img 
          src="/bird-banner.jpg" 
          alt="Wildlife Safari Adventure" 
          className="banner-image"
        />
        <div className="banner-content">
          <h1 className="banner-title animate-fade-in">
            <span><b>Bird</b></span> Watching Adventures
          </h1>
          <div className="banner-description animate-slide-up">
            <p>
             Step into the heart of nature’s wonders, where every path leads to breathtaking landscapes and hidden 
             treasures waiting to be found. Experience the thrill of discovering rare and fascinating species in their natural habitats, 
             from vibrant birds to elusive mammals. Let the whispers of the forest, the rustle of leaves, 
             and the songs of wildlife inspire you to connect deeply with the Earth and cherish its delicate beauty.
            </p>
            <Link to="/booking">
            <button className="book-now-btn animate-pulse">
              Book Your Adventure Now
            </button></Link>
          </div>
        </div>
      </div>


      {/* Wildlife Areas Section */}
      <div className="wildlife-areas-section">
        <h2 className="section-title">Explore Sri Lanka's Wildlife Parks</h2>
        <p className="section-subtitle">Home to leopards, elephants and diverse ecosystems</p>
        
        <div className="wildlife-areas-grid">
          {wildlifeAreas.map((area, index) => (
            <div className="wildlife-area-card" key={index}>
              <div className="area-image-container">
                <img 
                  src={area.image} 
                  alt={area.name} 
                  className="area-image"
                  loading="lazy"
                />
                <div className="area-overlay"></div>
              </div>
              <div className="area-info">
                <h3>{area.name}</h3>
                <p>{area.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* Info Cards */}
      <section className="info-section">
        <div className="info-card">
          <FaBinoculars className="icon" />
          <h3 className='desc-heading'>Guided Tours</h3>
          <p className='desc-para'>Join expert-led tours to spot rare and exotic birds in their natural habitats.</p>
        </div>
        <div className="info-card">
          <FaFeather className="icon" />
          <h3 className='desc-heading'>Bird Species</h3>
          <p className='desc-para'>Learn about hundreds of bird species and their unique characteristics.</p>
        </div>
        <div className="info-card">
          <FaMapMarkedAlt className="icon" />
          <h3 className='desc-heading'>Best Locations</h3>
          <p className='desc-para'>Discover the most scenic and bird-rich locations around the world.</p>
        </div>
      </section>







      {/* Quote Section */}
      <section className="quote-section">
        <blockquote>
          "Birds are indicators of the environment. If they are in trouble, we know we'll soon be in trouble."
        </blockquote>
        <cite>— Roger Tory Peterson</cite>
      </section>
    </div>
  );
}

export default BirdWatching;
